module.exports = __webpack_public_path__ + "img/zentria.9d277868.png";